export default __webpack_public_path__ + "static/media/tiktok-logo.eb3d45da.png";